
<script>
import { Pie, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

const options = {
  responsive: true,
  maintainAspectRatio: false,
  tooltips: {
    mode: "point"
  },
  legend: {
    display: false
  },
  animation: {
    duration: 1500
  }
};

export default {
  extends: Pie,
  mixins: [reactiveProp],
  mounted() {
    this.renderChart(this.chartData, options);
  }
};
</script>